module.exports = __webpack_public_path__ + "img/google10.b9dff158.jpg";